import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import UserServicesFactory from '../../user/Services/factory.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'

/**
 * @implements UseCase
 */
class AcceptPurchaseTermsTransactionsUseCase extends UseCase {
  #getCurrentUserService
  #httpTransactionsRepository

  constructor({getCurrentUserService, httpTransactionsRepository}) {
    super()
    this.#getCurrentUserService = getCurrentUserService
    this.#httpTransactionsRepository = httpTransactionsRepository
  }

  static create({config}) {
    return new AcceptPurchaseTermsTransactionsUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config}),
      httpTransactionsRepository: HTTPTransactionRepository.create({config})
    })
  }

  @inlineError
  async execute() {
    const userEntity = await this.#getCurrentUserService.execute()

    const [error] = await this.#httpTransactionsRepository.acceptPurchaseTerms({userEntity})

    if (error) throw error
  }
}

export const factory = AcceptPurchaseTermsTransactionsUseCase.create
